"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // this is a copy of 6wfeo
"default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _sixweeksfree = /*#__PURE__*/ _interop_require_default(require("../6wfeo/six-weeks-free"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '6wfeopb',
    rewards: [
        _sixweeksfree.default
    ]
};
